export default __webpack_public_path__ + "static/media/SOL.05baf3c2.png";